export default __webpack_public_path__ + "static/media/q7_02_sp.808dc1a7.jpg";